import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ListDefaults, SearchFilter, TableService } from '@fry/lib/list';
import { EASLinkAction } from '@fry/components/common/buttons/buttons.service';
import { BookingsStore } from '@fry/booking/lib/bookings';
import { ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs';
import { FieldType, FormField } from '@fry/lib/forms';
import { InteractiveTableOptions } from '@fry/components/common/list/interactive-table/interactive-table.component';


@Component({
    selector: 'eas-booking-list',
    templateUrl: './booking-list.component.html',
    providers: [
        TableService,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BookingListComponent implements OnInit, OnDestroy {

  public actions: EASLinkAction[] = [];

  public defaultColumns = [
    'user', 'stateName', 'createdDate', 'view', 'bookingOption', 'bookingItem'
  ];

  public tableComponentOptions: InteractiveTableOptions = {
    enableColumns: true,
    enableFilters: true,
    enableExport: true,
    enableSelection: false,
    itemSingleLabel: $localize `booking`,
    itemPluralLabel: $localize `bookings`,
    tableTitle: $localize `Bookings`,
  };

  constructor(

    private route: ActivatedRoute,
    private tableService: TableService,
    private bookingsStore: BookingsStore,
  ) { }

  private getExportFormFields(): FormField[] {
    return [
      {
        id: 'includeUserFields',
        type: FieldType.FIELD,
        title: $localize `Include profile fields`,
        initial: true,
        widget: {
          type: 'boolean'
        }
      },
      {
        id: 'includeFormFields',
        type: FieldType.FIELD,
        title: $localize `Include form data`,
        widget: {
          type: 'boolean'
        }
      }
    ];
  }

  ngOnInit() {
    this.route.params.pipe(
      switchMap(params => {
        const filter: SearchFilter = {};
        let listId = 'all-bookings';
        if (params.user) {
          filter.user = params.user;
          listId = 'user-bookings';
        }
        // const data = this.route.snapshot.data;
        const defaults: ListDefaults = { listType: 'table', engine: 'es', pageSize: 10 };
        defaults.fixedSearchModel = {
          filter,
          sort: {sort_on: 'createdDate', sort_order: 'desc'},
          select: ["bookingItem", "bookingOption", "user", "stateName", "createdDate", "modifiedDate", "view"],
          options: {
            includeFormFields: false,
            readableColumnId: '{{bookingOption}} for {{user}}'
          },
        };
        // defaults.hideFilters = ['bookingItem', 'bookingOptionUnique'];
        defaults.exportFormFields = this.getExportFormFields();
        defaults.featuredFilters = ['text', 'es_extra.stateName'];
        defaults.preserveState = true;
        return this.tableService
          .setupWith(this.bookingsStore,
                    defaults,
                    listId);
      })
    ).subscribe();

  }

  ngOnDestroy() { }
}
